import gql from 'graphql-tag';

export default gql`
  fragment mailCampaignBlockTitleFragment on MailCampaignBlockTitle {
    id
    bodyColor
    textColor
    textHtml
    plainText
    paddingTop
    paddingBottom
    paddingLeft
    paddingRight
    lineHeight
    createdAt
    updatedAt
  }
`;
